import { useState } from "react";
import {Menus} from "../img/DataImg"
import {Link} from "react-router-dom";
import {Routes, Route} from "react-router-dom";
import Dashboard from "./simple/Dashboard";
import Settings from "./simple/Settings";
import {MenuIcon,  ChevronLeftIcon } from "@heroicons/react/solid"
import Alerts from "./simple/Alerts";
import History from "./simple/History"

const Base = () => {

  const [open, setOpen] = useState(false);
  const [MenuR, setMenuR ] = useState(false)

  const name_app = 'IoTHome'

  return (
    <div className="flex">

      <nav className="absolute z-50 w-full border-gray-200 px-2 sm:px-4 py-2.5 sm:hidden bg-gray-900">
        <div className="container flex flex-wrap justify-between items-center mx-auto">
        <div className="flex items-center">
        <img
            src="https://firebasestorage.googleapis.com/v0/b/node-mcu-iot-635e6.appspot.com/o/logo_iot.png?alt=media&token=e09bed50-f409-436d-9812-df85cf810948"
            className={`mr-3 h-10 sm:h-9 cursor-pointer duration-500`}
          />
          <span className="self-center text-xl font-semibold whitespace-nowrap text-white">{name_app}</span>
        </div>

        <div className="flex md:order-2">
            <button data-collapse-toggle="mobile-menu-4" type="button" className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden
              focus:outline-none focus:ring-2  dark:text-gray-400 hover:bg-gray-700
              focus:ring-gray-600" aria-controls="mobile-menu-4" aria-expanded="false" onClick={()=>setMenuR(!MenuR)}>
            <MenuIcon className="h-6 w-6 fill-white"/>
          </button>
        </div>
        <div className={`${!MenuR && "hidden"} justify-between items-center w-full md:flex md:w-auto md:order-1`} id="mobile-menu-4">
          <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium ">

            {Menus.map((Menu, index) => (
            <Link to={Menu.page} key={index} onClick={()=>setMenuR(false)}><li
              className={`flex  rounded-md p-2 cursor-pointer hover:bg-blue-700  text-white text-sm items-center gap-x-4 
              ${Menu.gap ? "mt-9" : "mt-2"} `}>
              {Menu.img}
              <span>
                {Menu.title}
              </span>
            </li></Link>
          ))}
          </ul>
        </div>
        </div>
      </nav>
      
      <div
        className={` ${
          open ? "w-72" : "w-20 "
        } bg-gray-900 h-screen p-5  pt-8 relative duration-300 hidden sm:inline-block`}
      >

        <ChevronLeftIcon className={`absolute cursor-pointer -right-3 top-9 h-6 w-6 border-dark-purple bg-white
           border-2 rounded-full  ${!open && "rotate-180"}`} onClick={() => setOpen(!open)}/>
        <div className="flex gap-x-4 items-center">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/node-mcu-iot-635e6.appspot.com/o/logo_iot.png?alt=media&token=e09bed50-f409-436d-9812-df85cf810948"
            className={`cursor-pointer duration-500 ${
              open && "rotate-[360deg]"
            }`} alt=""
          />
          <h1
            className={`text-white origin-left font-medium text-xl duration-200 ${
              !open && "scale-0"
            }`}
          >
            {name_app}
          </h1>
        </div>
        <ul className="pt-6">
          {Menus.map((Menu, index) => (
            <Link to={Menu.page} key={index}><li
              className={`flex  rounded-md p-2 cursor-pointer hover:bg-blue-700 text-gray-300 text-sm items-center gap-x-4 
              ${Menu.gap ? "mt-9" : "mt-2"} `}>
              {/*<img src={`../../assets/${Menu.src}.png`} alt=""/>*/}
              {Menu.img}
              <span className={`${!open && "hidden"} origin-left duration-200`}>
                {Menu.title}
              </span>
            </li></Link>
          ))}
        </ul>
      </div>

      <div className="h-screen grow p-4 sm:p-7 bg-gray-100 overflow-auto" onClick={()=>setMenuR(false)}>
        <Routes>
          <Route path="/history" element={<History />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/setting" element={<Settings />} />
          <Route path="/" element={<Dashboard />} />
        </Routes>
                
      </div>
    </div>
  );
};
export default Base;